import { useTranslate } from '@refinedev/core';
import { Dropdown, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import { ModStatus } from '@/api/generated/schemas';
import { useBulkModStatus } from '@/hooks/user_catalog/useBulkModStatus';

interface BulkModStatusControlProps {
  /** Refine resource string, e.g. `user_catalog.tags` */
  resource: string;
  /** Row ids to update (selected rows in List, single record in Show). */
  ids: number[];
  disabled?: boolean;
  onSuccess?: () => void;
  size?: SizeType;
}

/**
 * Dropdown of `mod_status` values. Picking one confirms then applies to `ids`.
 * Shared by List (bulk over selected rows) and Show (single record) views.
 */
export const BulkModStatusControl = ({
  resource,
  ids,
  disabled,
  onSuccess,
  size,
}: BulkModStatusControlProps) => {
  const t = useTranslate();
  const { update, isLoading } = useBulkModStatus({ resource });

  const items = Object.values(ModStatus).map((value) => ({
    key: value,
    label: t(`base.mod_status.${value}`),
  }));

  return (
    <Dropdown
      trigger={['click']}
      disabled={disabled || ids.length === 0}
      menu={{
        items,
        onClick: ({ key }) => update(ids, key as ModStatus, onSuccess),
      }}
    >
      <Button type="primary" size={size} loading={isLoading}>
        {t('user_catalog.common.bulk_mod_status.apply')} <DownOutlined />
      </Button>
    </Dropdown>
  );
};
